import React, { useEffect } from "react";
import { Box, Typography, Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useModule } from "../../context/ModuleContext";

export default function Tools() {
  const navigate = useNavigate();
  const { selectedModule } = useModule();

  // Redirect if user refreshes or opens directly
  useEffect(() => {
    if (!selectedModule) {
      navigate("/ModulesLandingPage");
    }
  }, [selectedModule, navigate]);

  if (!selectedModule) return null;

  return (
    <div style={{ padding: "2rem" }}>
      <Typography variant="h4" gutterBottom>
        Welcome to {selectedModule.name} Page
      </Typography>

      <Box
        sx={{
          backgroundColor: "#f1f1f1",
          padding: "24px",
          borderRadius: "12px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          marginTop: "20px",
        }}
      >
        <Grid container spacing={2}>
          {selectedModule.functions?.map((func, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Box
                sx={{
                  backgroundColor: "#fff",
                  padding: "16px",
                  borderRadius: "10px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                  textAlign: "center",
                }}
              >
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => navigate(func.uriPath)}
                  sx={{ mt: 2 }}
                >
                  {func.name}
                </Button>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </div>
  );
}
